import { DataGridMui } from "src/shared/container/data-grid-mui"
import { getAuditSummaryColumns } from "./getAuditSummaryColumns"
import { useMemo, useState } from "react"
import {
  AuditLotStatus,
  FilterCondition,
  FilterOperator,
  LogicalOperator,
  SortDirection,
  useGetAllAuditLotsQuery
} from "src/graphql/quark/quark.type"
import { Button } from "@mui/material"
import OutlinedInput from "src/shared/components/outlined-input"
import { Search as SearchIcon } from "@mui/icons-material"
import { useTypedSelector } from "src/shared/store/store"

const AuditSummaryTable = ({ productId }: { productId: string }) => {
  const currentWhLoc = useTypedSelector((state) => state.authentication.currentWhLoc)
  const columns = useMemo(() => getAuditSummaryColumns(), [])
  const [pagination, setPagination] = useState({ pageIndex: 0, pageSize: 10 })
  const [filters, setFilters] = useState<{ id: string; value: string }[]>([])
  const [sorting, setSorting] = useState<{ id?: null | string; desc?: null | boolean }>({
    id: "createdAt",
    desc: true
  })

  const filterConditions: FilterCondition[] = useMemo(() => {
    if (!filters?.length) return []
    return filters.map(
      (val) =>
        ({
          operator: ["id", "status"].includes(val.id) ? FilterOperator.Equal : FilterOperator.Like,
          field: val.id,
          value: val.value
        }) as FilterCondition
    )
  }, [filters])
  const { data, loading, refetch } = useGetAllAuditLotsQuery({
    fetchPolicy: "network-only",
    variables: {
      limit: pagination.pageSize,
      page: pagination.pageIndex + 1,
      sort: [{ direction: sorting.desc ? SortDirection.Desc : SortDirection.Asc, field: sorting.id as string }],
      locationId: currentWhLoc?.id as string,
      filter: [
        {
          conditions: [
            {
              operator: FilterOperator.Equal,
              field: "auditProductId",
              value: productId
            },
            {
              operator: FilterOperator.Ne,
              field: "status",
              value: AuditLotStatus.Matched
            },

            ...filterConditions
          ],
          logicalOperator: LogicalOperator.And
        }
      ]
    }
  })

  return (
    <DataGridMui
      id="audit-product-lot-list-for-summary"
      data={data?.getAllAuditLots.data || []}
      isLoading={loading}
      enableSorting={false}
      columns={columns}
      paginationModel={pagination}
      paginationMode="server"
      sortingMode="server"
      filterMode="server"
      rowsPerPageOptions={[10, 15, 20]}
      initialPageSize={10}
      skeletonCount={10}
      sortingModel={sorting as any}
      onSortModelChange={setSorting}
      enableColumnFilters
      onFilterChange={setFilters}
      onPaginationChange={setPagination}
      pageCount={data?.getAllAuditLots?.meta?.totalCount ?? undefined}
      leftComponent={
        //   <Conditional condition={hasPermission("procurement:vendor:search")}>
        <OutlinedInput
          onKeyDown={(e) => {
            if (e.key === "Enter") {
              const val = (e.target as HTMLInputElement).value
              setFilters((prev) => {
                const data = [...prev]
                const nameIndex = data?.findIndex((prev) => prev.id === "actionId")
                if (nameIndex === -1) {
                  data.push({ id: "actionId", value: val as string })
                  return data
                } else {
                  if (!val) return data.filter((prev) => prev.id !== "actionId")

                  data[nameIndex].value = val as string
                  return data
                }
              })
            }
          }}
          variant="rounded"
          startAdornment={<SearchIcon />}
          placeholder="Search by Action ID"
          size="small"
        />
        //   </Conditional>
      }
      rightComponent={
        <Button
          onClick={() => {
            refetch()
          }}
        >
          sync
        </Button>
      }
    />
  )
}

export default AuditSummaryTable
